import { Injectable, inject } from "@angular/core";
import { DashboardResource, FilesResource } from "core/stages-client";

type File = stages.file.File;
type Element = stages.dashboard.Element;

export class EditableDescription {
	description!: stages.core.DisplayDescription;
	isEditable?: boolean;
}

@Injectable({ providedIn: "root" })
export class DashboardService {
	private readonly dashboardResource = inject(DashboardResource);
	private readonly filesResource = inject(FilesResource);

	async getMyMostFrequentlyUsedElements(workspaceId: string, pv: string): Promise<PagedResult<Element>> {
		return this.dashboardResource.getMyMostFrequentlyUsedElements({
			workspaceId: workspaceId,
			pv: pv,
		});
	}

	async getRecentlyUsedFiles(currentWorkspaceId: string, pv: string): Promise<File[]> {
		return this.filesResource.getRecentlyUsedFiles({
			workspaceId: currentWorkspaceId,
			pv: pv,
		});
	}
}
